import { Modal } from "antd";

export default function ImageModal({ imageUrl, open, onClose }) {
    const url_media = process.env.REACT_APP_MEDIA_URL;
    return (
        <Modal visible={open} onCancel={onClose} footer={null}>

            <img
                src={`${url_media}/${imageUrl}`}
                alt="full-view"
                className="p-3"
                style={{ width: '100%', height: 'auto' }}
            />

        </Modal>
    );
}
